import React from "react";
import { DirectionalHint, Icon, Label, TooltipHost, useTheme } from "@fluentui/react";
import { isNullOrEmpty } from "../utilities";
import { useForceUpdate } from "../hooks/useForceState";
export const XTreeView = (props) => {
    var _a, _b;
    const theme = useTheme();
    const forceUpdate = useForceUpdate();
    if (props.node == null)
        return React.createElement(React.Fragment, null);
    const onContextMenu = (e) => {
        e.nativeEvent.preventDefault();
        e.nativeEvent.stopPropagation();
        if (typeof props.node.onContextMenu === 'function') {
            props.node.onContextMenu(e.nativeEvent.target.offsetLeft + e.nativeEvent.layerX + 5, e.nativeEvent.target.offsetTop + e.nativeEvent.layerY + 100);
        }
    };
    const onClick = (e) => {
        e.nativeEvent.preventDefault();
        e.nativeEvent.stopPropagation();
        props.node.isSelected = true;
        forceUpdate();
        if (typeof props.node.onClick === 'function')
            props.node.onClick();
    };
    const onDoubleClick = () => {
        if (typeof props.node.onDoubleClick === 'function') {
            if (!isDisabled) {
                props.node.onDoubleClick();
            }
        }
        else {
            if (props.node.children.length > 0) {
                onExpandNodeClick();
            }
        }
    };
    const onExpandNodeClick = () => {
        props.node.isCollapsed = !props.node.isCollapsed;
        forceUpdate();
    };
    props.node.onChanged = () => forceUpdate();
    const draggable = typeof props.node.onDragStart === 'function';
    const onDragStart = () => {
        if (draggable) {
            props.node.onDragStart();
        }
    };
    if (props.node.visible === false)
        return React.createElement(React.Fragment, null);
    const isDisabled = typeof props.node.disabled === 'boolean' && props.node.disabled === true;
    const TREE_NODE_STYLE = {
        userSelect: "none",
        verticalAlign: "top",
        display: "inline-block",
        fontWeight: "bold",
        height: "16px",
        width: "16px",
        fontSize: "16px",
        color: theme.palette.black,
        cursor: "pointer"
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { onContextMenu: onContextMenu, className: 'treenode-line' },
            React.createElement("div", { style: TREE_NODE_STYLE }, props.node.children.length > 0 && React.createElement(Icon, { iconName: props.node.isCollapsed === true ? 'ExploreContentSingle' : 'CollapseContentSingle', onClick: onExpandNodeClick })),
            !isNullOrEmpty(props.node.icon) && React.createElement("div", { className: "treenode-icon" },
                props.useIcons && React.createElement("img", { src: props.node.icon, style: { height: '20px' } }),
                !props.useIcons && React.createElement(Icon, { iconName: props.node.icon })),
            React.createElement("div", { className: `treenode-text` + (isDisabled ? ' treenode-disabled' : ' io-node-enabled') },
                React.createElement(TooltipHost, { directionalHint: DirectionalHint.rightCenter, content: ((_b = (_a = props.node).onRenderTooltip) === null || _b === void 0 ? void 0 : _b.call(_a)) || React.createElement(Label, null, props.node.tooltip || props.node.text) },
                    React.createElement("span", { onClick: onClick, onDoubleClick: onDoubleClick, onContextMenu: onContextMenu, style: Object.assign(Object.assign({}, props.node.style), { fontWeight: props.node.isSelected ? 'bold' : 'normal', userSelect: "none" }), draggable: draggable, onDragStart: onDragStart }, props.node.text)))),
        React.createElement("ul", { className: "io-ps-treeview" }, props.node.visible && !props.node.isCollapsed && props.node.children.map((child) => React.createElement("li", { key: child.id },
            React.createElement(XTreeView, { node: child, allowSelect: props.allowSelect, useIcons: props.useIcons })))));
};
